import { State } from '../types';

/**
 * This method is used for showing all other discounts promotions on popover
 **/
export function getAppliedPromotions(state: State, identifier: string, isApp: boolean) {
  const allPromotions = (() => {
    if (isApp) {
      // finding specific app from the state to get all promotions
      const appDetail = Object.values(state?.linkedEntitlements)
        ?.flatMap((item) => item)
        ?.find((app) => app.id === identifier);

      // merging both existing promotions and new promotions
      return [...(appDetail?.promotions ?? []), ...(state?.selectedLinkedEntitlements?.[identifier]?.promotions ?? [])];
    }
    return [...(state.products?.[identifier]?.promotions ?? [])];
  })();

  const promotionsToRemove = (() => {
    if (isApp) {
      return state.selectedLinkedEntitlements?.[identifier]?.removePromotions ?? [];
    }
    return state.selectedProducts?.[identifier]?.removePromotions ?? [];
  })();

  // checking if promotion is already applied and that promotion is to remove
  const appliedPromotions = allPromotions?.filter((promotion) => {
    const isPromotionToRemove = promotionsToRemove?.some(
      (promo) => promo?.promotionInstanceId === promotion?.promotionInstanceId
    );
    return promotion?.type !== 'PARTNER_DISCOUNT' && !isPromotionToRemove;
  });

  return appliedPromotions;
}
